import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import { fetchApi } from '../../services/apiService';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const CategoryAutocomplete = forwardRef((props, ref) => {
    const { allOption = false, selectedValues = [], disabled = false, editMode = false, reload, categoryFor = 1, forSuperCategory = null, forRefurbishable = null, onlyTaskInventoryCategory = null, isParent = 'Y', parentCategoryId = '', isFormikFormField = false, showFormError = false, width = '100%', listWidth = width, ...rest } = props;
    let jobCardCategoryOptions = [];
    if (allOption) {
        jobCardCategoryOptions.push({ categoryTitle: isParent === 'N' ? 'All Sub Categories' : 'All Categories', categoryId: '' });
    }
    let initialProps = {
        ...rest,
        labelKey: 'categoryTitle',
        primaryKey: 'categoryId',
        options: jobCardCategoryOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        width,
        listWidth,
        dataLoaded: false,
        editMode,
        disabled
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getCategoryOptions = async () => {
            let getCategoryParams = { categoryFor, isParent, status: 1 };
            let eventName = 'getCategory';
            if (parentCategoryId !== '') {
                getCategoryParams = { ...getCategoryParams, parentCategoryId }
            }
            if(forSuperCategory && forSuperCategory !== ''){
                getCategoryParams = { ...getCategoryParams, searchSuperCategories:forSuperCategory }
            }
            if(forRefurbishable && forRefurbishable !== ''){
                getCategoryParams = { ...getCategoryParams, onlyRefurbishable:forRefurbishable }
            }
             if(onlyTaskInventoryCategory && onlyTaskInventoryCategory !== ''){
                getCategoryParams = { ...getCategoryParams, onlyTaskInventoryCategory:onlyTaskInventoryCategory }
            }
            if (isParent === 'N') {
                eventName = 'getSubCategory';
            }
            
            const response = await fetchApi(`masters/${eventName}`, getCategoryParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (allOption) {
                    newOptions.push({ categoryTitle: isParent === 'N' ? 'All Sub Categories' : 'All Categories', categoryId: '' });
                }
                if (response.data.categories.length > 0) {
                    newOptions = newOptions.concat(response.data.categories);
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((c) => selectedValues.indexOf(c.categoryId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getCategoryOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parentCategoryId, reload]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((c) => selectedValues.indexOf(c.categoryId) >= 0);
        }
        setDefaultProps({ ...defaultProps, editMode, preSelectedValues, dataLoaded: !editMode });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMode, selectedValues]);
    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    return (defaultProps.dataLoaded || editMode ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default CategoryAutocomplete;